import { useTheme } from '../../contexts/ThemeContext.jsx';

const OPTIONS = [
  { value: 'system', label: 'System', desc: 'Follow your device theme automatically. Reacts live if you toggle your OS setting.' },
  { value: 'light',  label: 'Light',  desc: 'Force the light palette — white surfaces, dark text.' },
  { value: 'dark',   label: 'Dark',   desc: 'Force the dark palette — near-black surfaces, amber accents.' },
];

export default function Appearance() {
  const { theme, effective, setTheme } = useTheme();

  return (
    <div className="account-page">
      <header className="account-page-head">
        <h1>Appearance</h1>
        <p className="muted">
          Customise how Markaii looks on this device. Saved per browser
          (per profile / per device — not synced across machines).
        </p>
      </header>

      <section className="account-section">
        <h2>Theme</h2>
        <p className="muted small">Currently rendering: <b>{effective}</b>{theme === 'system' && ' (via system preference)'}</p>
        <div className="theme-grid">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`theme-card theme-pickable ${theme === opt.value ? 'theme-card-active' : ''}`}
              onClick={() => setTheme(opt.value)}
              aria-pressed={theme === opt.value}
            >
              <div className={`theme-card-swatch theme-swatch-${opt.value === 'system' ? 'system' : opt.value}`} />
              <div className="theme-card-body">
                <div className="theme-card-title">{opt.label}</div>
                <p className="muted small">{opt.desc}</p>
              </div>
              {theme === opt.value && <span className="theme-card-check" aria-hidden="true">✓</span>}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
